import {useCallback, useEffect, useState} from "react";
import {Airfield} from "../../models/Airfield";
import {
	Box,
	Container,
	debounce,
	Divider,
	FormControl,
	Grid,
	IconButton,
	InputAdornment,
	InputLabel,
	Menu,
	MenuItem,
	Select,
	TablePagination,
	TextField,
	Typography,
	useMediaQuery,
	useTheme
} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import {PaginationResult} from "../../types/paginationResult";
import AirfieldsPublicList from "./AirifieldsPublicList";
import AirfieldsList from "./AirfieldsList";
import SearchIcon from '../../icons/Search';
import {AirfieldService} from "../../services/AirfieldService";
import AirfieldsPublicMobileList from "./AirfieldsPublicMobileList";
import AirfieldMobileListCard from "./AirfieldMobileListCard";
import TocIcon from '@material-ui/icons/Toc';
import ArtTrackIcon from '@material-ui/icons/ArtTrack';
import {RegionService} from "../../services/RegionService";
import {Region} from "../../models/Region";
import {Province} from "../../models/Province";
import AirfieldsMap from "../../components/AirfieldsMap";
import {AirfieldCoordinates} from "../../models/AirfieldCoordinates";
import MapIcon from '@mui/icons-material/Map';
import CircularProgress from '@mui/material/CircularProgress';


const AirfieldPublicIndex = () => {
	const [airfields, setAirfields] = useState<PaginationResult<Airfield>>();
	const emptyAirfields: PaginationResult<Airfield> = {
		items: [],
		totalPages: 1,
		currentPages: 1,
		totalCount: 1
	};

	var currentTheme = useTheme();
	const isSpaceForLabelRows = useMediaQuery(currentTheme.breakpoints.down(430));
	const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);


	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setMenuAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setMenuAnchorEl(null);
	};




	const { t } = useTranslation();
	const [isPageLoading, setIsPageLoading] = useState<boolean>(true);
	const [sortedPronvinceList, setSortedPronvinceList] = useState<string[]>([]);
	const [pageVisualMode, setPageVisualMode] = useState<string>("map");//cards, list, map
	const [currentPage, setCurrentPage] = useState<number>(0);
	const [regionChoosen, setRegionChoosen] = useState<string>("");
	const [provinceChoosen, setProvinceChoosen] = useState<string>("");
	const [nationChoosen, setNationChoosen] = useState<string>("");
	const [regionsList, setRegionsList] = useState<Region[]>([]);


	const [recordLimit, setRecordLimit] = useState<number>(10);//(recordLimitInput? recordLimitInput:10));
	const [searchFilter, setSearchFilter] = useState<string>("");//(searchFilterInput? searchFilterInput:""));

	var currentTheme = useTheme();

	var isMobile = useMediaQuery(currentTheme.breakpoints.down('md'));

	const getAirfields = useCallback(debounce(async (currentPage: number, recordLimit: number, searchFilter: string, region: string, province: string) => {
		const airfieldService = new AirfieldService();

		if ((pageVisualMode == "cards") || (pageVisualMode == "list")) {
			try {
				const retrievedAirfields = await airfieldService.getAllAirfieldsWithFirstPhoto(searchFilter, currentPage + 1, recordLimit, region, province);
				setAirfields(retrievedAirfields);
			} catch (error) {
				//TODO: Handle errors
				console.log(error);
			}
		}

		setIsPageLoading(false);

		return null;
	}, 700), [pageVisualMode]);


	const [airfieldsCoordinates, setAirfieldsCoordinates] = useState<AirfieldCoordinates[]>([])

	const getAirfieldsCoordinates = useCallback(debounce(async (_searchFilter: string, _region: string, _province: string) => {
		const airfieldService = new AirfieldService();
		const retrievedAirfieldsC = await airfieldService.getAllAirfieldsCoordinates(_searchFilter, _region, _province);
		setAirfieldsCoordinates(retrievedAirfieldsC);
		setIsPageLoading(false);

		return null;
	}, 700), []);


	const getRegions = useCallback(async () => {
		try {
			const regionService = new RegionService();
			const retrievedRegions = await regionService.getAllRegions();
			var tempArray = [] as string[];
			setRegionsList(retrievedRegions);

			//SortedProvince
			retrievedRegions.map((region: Region, index) => {
				region.provincesList.map((prov: Province, index) => {
					tempArray.push(prov.name);
				})
			})
			setSortedPronvinceList(tempArray.sort());
			//SortedProvince END



		} catch (error) {
			//TODO: Handle errors
			console.log(error);
		}
		return null;
	}, []);

	useEffect(() => {
		(async () => {
			await getRegions();
			setRegionChoosen("noRegion");
			setProvinceChoosen("noProvince");
			setNationChoosen("italy");
		})();

	}, [])


	useEffect(() => {
		(async () => {
			setIsPageLoading(true);
			if (pageVisualMode == "map")
				await getAirfieldsCoordinates(searchFilter, regionChoosen, provinceChoosen);
			else
				await getAirfields(currentPage, recordLimit, searchFilter, regionChoosen, provinceChoosen);
		})();
	}, [pageVisualMode, searchFilter, currentPage, recordLimit, regionChoosen, provinceChoosen])



	return (<>
		<Container fixed>

			<Grid
				container
				justifyContent="space-between"
				spacing={2}
			>
				<Grid item
					lg={3}
					md={3}
					xs={6}>
					<Typography
						color="textPrimary"
						variant="h5"
						sx={{ mt: 1 }}
					>
						{t('AIRFIELDS_LIST')}
					</Typography>
				</Grid>

				{useMediaQuery(currentTheme.breakpoints.down("md")) &&
					<Grid item
						lg={3}
						md={3}
						xs={6}
						sx={{ display: 'flex', justifyContent: 'flex-end', mt:3 }}>
						<IconButton
							onClick={(event: any) => setMenuAnchorEl(event.currentTarget)}
						>
							{(pageVisualMode == "cards") &&
								<ArtTrackIcon sx={{ color: "primary" }} fontSize="large" />}
							{(pageVisualMode == "list") &&
								<TocIcon sx={{ color: "primary" }} fontSize="large" />}
							{(pageVisualMode == "map") &&
								<MapIcon sx={{ color: "primary" }} fontSize="large" />}
						</IconButton>
						<Menu
							id="flights-approved-menu"
							MenuListProps={{
								'aria-labelledby': 'flight-approved-button',
							}}
							anchorEl={menuAnchorEl}
							open={Boolean(menuAnchorEl)}
							onClose={() => { setMenuAnchorEl(null) }}
						>

							<MenuItem key={'cardsPage'} onClick={() => { setMenuAnchorEl(null); setPageVisualMode("cards"); }} >
								{<ArtTrackIcon sx={{ mr: 2 }} fontSize="medium" color="success" />}
								<Typography fontSize="small">{" " + t('CARDS')}</Typography>

							</MenuItem>
							<MenuItem key={'listPage'} onClick={() => { setMenuAnchorEl(null); setPageVisualMode("list"); }} >
								{<TocIcon sx={{ mr: 2 }} fontSize="medium" color="error" />}
								<Typography fontSize="small">{" " + t('LIST')}</Typography>
							</MenuItem>
							<MenuItem key={'mapPage'} onClick={() => { setMenuAnchorEl(null); setPageVisualMode("map"); }} >
								{<MapIcon sx={{ mr: 2 }} fontSize="medium" color="error" />}
								<Typography fontSize="small">{" " + t('MAP')}</Typography>
							</MenuItem>
						</Menu>
					</Grid>
				}

				<Grid item
					lg={2}
					md={2}
					xs={12}>

					<FormControl fullWidth size='small'>
						<InputLabel>{t('NATION_LABEL')}</InputLabel>
						<Select
							label={t('NATION')}
							name="nation"
							onChange={(e) => {
								//setProvinceChoosen("noProvince"); setRegionChoosen("noRegion");
								setNationChoosen(e.target.value);
								//setCurrentPage(0);
							}}
							sx={{ color: 'white', mt: 1 }}
							value={nationChoosen}
							MenuProps={{ sx: { maxHeight: 350 } }}
						>
							<MenuItem key={"noNation"} value={"noNation"}>
								{t("SELECT_NATION")}
							</MenuItem>
							<MenuItem key={"italy"} value={"italy"}>
								{t("ITALY")}
							</MenuItem>
						</Select>
					</FormControl>
				</Grid>

				<Grid item
					lg={2}
					md={2}
					xs={6}>

					<FormControl fullWidth size='small'>
						<InputLabel>{t('REGION_LABEL')}</InputLabel>
						<Select
							label={t('REGION')}
							name="region"
							onChange={(e) => {
								setProvinceChoosen("noProvince"); setRegionChoosen(e.target.value)
								setCurrentPage(0);
							}}
							sx={{ color: 'white', mt: 1 }}
							value={regionChoosen}
							MenuProps={{ sx: { maxHeight: 350 } }}
						>
							<MenuItem key={"noRegion"} value={"noRegion"}>
								{t("SELECT_REGION")}
							</MenuItem>
							{regionsList.map((region: Region) => (
								<MenuItem key={region.id} value={region.regionName}>
									{region.regionName}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</Grid>



				<Grid item
					lg={2}
					md={2}
					xs={6}>

					<FormControl fullWidth size='small'>
						<InputLabel>{t('PROVINCE_LABEL')}</InputLabel>
						<Select
							label={t('PROVINCE')}
							name="province"
							onChange={(e) => { setProvinceChoosen(e.target.value); setCurrentPage(0); }}
							sx={{ color: 'white', mt: 1 }}
							value={provinceChoosen}
							MenuProps={{ sx: { maxHeight: 350 } }}
						>
							<MenuItem key={"noProvince"} value={"noProvince"}>
								{t("SELECT_PROVINCE")}
							</MenuItem>


							{(regionChoosen == "noRegion" || regionChoosen == "") ?
								sortedPronvinceList.map((province: string) => (
									<MenuItem key={province} value={province}>
										{province}
									</MenuItem>
								))
								:
								regionsList.map((region: Region) => (
									regionChoosen == region.regionName &&
									region.provincesList.map((province: Province) =>

										<MenuItem key={province.name} value={province.name}>
											{province.name}
										</MenuItem>
									)
								))
							}

						</Select>
					</FormControl>
				</Grid>
				{!useMediaQuery(currentTheme.breakpoints.down("md")) &&
					<Grid item
						lg={3}
						md={3}
						xs={6}
						sx={{ display: 'flex', justifyContent: 'flex-end', mt:10 }}>
						<IconButton
							onClick={(event: any) => setMenuAnchorEl(event.currentTarget)}
						>
							{(pageVisualMode == "cards") &&
								<ArtTrackIcon sx={{ color: "primary" }} fontSize="large" />}
							{(pageVisualMode == "list") &&
								<TocIcon sx={{ color: "primary" }} fontSize="large" />}
							{(pageVisualMode == "map") &&
								<MapIcon sx={{ color: "primary" }} fontSize="large" />}
						</IconButton>
						<Menu
							id="flights-approved-menu"
							MenuListProps={{
								'aria-labelledby': 'flight-approved-button',
							}}
							anchorEl={menuAnchorEl}
							open={Boolean(menuAnchorEl)}
							onClose={() => { setMenuAnchorEl(null) }}
						>

							<MenuItem key={'cardsPage'} onClick={() => { setMenuAnchorEl(null); setPageVisualMode("cards"); }} >
								{<ArtTrackIcon sx={{ mr: 2 }} fontSize="medium" color="success" />}
								<Typography sx={{}} fontSize="small">{" " + t('CARDS')}</Typography>

							</MenuItem>
							<MenuItem key={'listPage'} onClick={() => { setMenuAnchorEl(null); setPageVisualMode("list"); }} >
								{<TocIcon sx={{ mr: 2 }} fontSize="medium" color="error" />}
								<Typography sx={{}} fontSize="small">{" " + t('LIST')}</Typography>
							</MenuItem>
							<MenuItem key={'mapPage'} onClick={() => { setMenuAnchorEl(null); setPageVisualMode("map"); }} >
								{<MapIcon sx={{ mr: 2 }} fontSize="medium" color="error" />}
								<Typography sx={{}} fontSize="small">{" " + t('MAP')}</Typography>
							</MenuItem>
						</Menu>
					</Grid>
				}
			</Grid>
			<Divider sx={{ mt: 2, mb: 2 }} />
			<TextField
				fullWidth
				size='small'
				sx={{
					input: {
						color: 'white'
					}
				}}
				InputProps={{
					startAdornment: (
						<InputAdornment position="start">
							<SearchIcon fontSize="small" />
						</InputAdornment>
					),
					endAdornment: (
						<InputAdornment position="end" >
							{isPageLoading && <CircularProgress size={25} />}
						</InputAdornment>
					),
				}}
				onChange={(e) => {
					setSearchFilter(e.target.value);
					setCurrentPage(0);

				}}
				placeholder={t('SEARCH_AIRFIELDS')}
				value={searchFilter}
				variant="outlined"
			/>

			{!isMobile ? (<>
				{(pageVisualMode == "cards") &&
					<AirfieldsPublicList
						airfields={airfields ? airfields : emptyAirfields}
						recordLimit={recordLimit}
						isLoading={isPageLoading} />}



				{(pageVisualMode == "list") &&
					(<><AirfieldsList
						airfields={airfields ? airfields : emptyAirfields}
						recordLimit={recordLimit}
						isLoading={isPageLoading}
					/></>)}

				{(pageVisualMode == "map") &&
					(<Box sx={{ mt: 1 }}>
						<AirfieldsMap
							airfieldsCoordinates={airfieldsCoordinates}
							isLoading={isPageLoading} /></Box>)}
			</>) :
				(<>
					{(pageVisualMode == "cards") &&
						(<><AirfieldsPublicMobileList
							airfields={airfields ? airfields : emptyAirfields}
							recordLimit={recordLimit}
							isLoading={isPageLoading} /></>
						)}
					{(pageVisualMode == "list") &&
						(<><AirfieldMobileListCard
							airfields={airfields ? airfields : emptyAirfields}
							recordLimit={recordLimit}
							isLoading={isPageLoading} /></>
						)

					}
					{pageVisualMode == "map" &&

						<Box sx={{ mt: 1 }}>
							<AirfieldsMap
								airfieldsCoordinates={airfieldsCoordinates}
								isLoading={isPageLoading} /></Box>

					}

				</>)
			}


			{pageVisualMode != "map" &&
				<Box sx={{
					display: 'flex',
					justifyContent: (!isSpaceForLabelRows ? 'flex-end' : 'center'),
				}}>
					<TablePagination
						component="div"
						count={airfields?.totalCount ?? 10}
						onRowsPerPageChange={(e) => {
							setRecordLimit(parseInt(e.target.value, 10));
							var maxPage = ((airfields?.totalCount ? airfields.totalCount : 10) / parseInt(e.target.value, 10));
							maxPage = Math.round(maxPage);
							setCurrentPage(maxPage > currentPage ? currentPage : Math.max(maxPage - 1, 0));
						}}
						onPageChange={(e, page) => {
							var maxPage = ((airfields?.totalCount ? airfields.totalCount : 10) / recordLimit);
							maxPage = Math.round(maxPage);
							setCurrentPage(maxPage > page ? page : Math.max(maxPage - 1, 0));
						}}
						page={currentPage}
						rowsPerPage={recordLimit}
						rowsPerPageOptions={[5, 10, 25]}
						labelRowsPerPage={!isSpaceForLabelRows && t('ROWS_PER_PAGE')}
					/>
				</Box>}
		</Container>
		<br></br>
	</>
	)
};

export default AirfieldPublicIndex;
